/* global _portone_payment_blocks */

import {_} from 'underscore';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { getSetting } from '@woocommerce/settings';
import { PafwContent, PafwLabel } from './pafw';
import { PafwSubscriptionContent } from './pafw-subscription';
import { PafwEximbayContent } from './pafw-eximbay';

_.each( _portone_payment_blocks.supported_payment_methods, function( gateway_id ) {
    let settings = getSetting( gateway_id + '_data', {} );

    console.log( settings );

    if( !_.isEmpty( settings ) && !_.isUndefined( settings ) ) {
        let PaymentMethod = {
            name: gateway_id,
            label: <PafwLabel settings={ settings }/>,
            content: 'iamport_eximbay' === settings.name ? <PafwEximbayContent settings={ settings }/> : <PafwContent settings={ settings }/>,
            edit: <PafwContent settings={ settings }/>,
            canMakePayment: () => true,
            ariaLabel: settings.title,
            supports: {
                features: settings.supports,
            },
        };

        registerPaymentMethod( PaymentMethod );
    }
} );